<template>
  <div class="header-content">
    <template v-if="!isH5()">
      <div class='w-full h-[60px] bg-black-950 flex justify-center sticky top-0 z-[999] h-[${HEADER_HEIGHT}px]'>
        <div class="siteHeader">
          <img src="https://static-jp.theckb.com/static-asset/sellerstation/seller_logo2.png" alt=""
            class="h-[28px] cursor-pointer" @click="jumpIndex" />
          <div class="flex-1" />
          <a class=" text-[1rem] font-[800] cursor-pointer mr-[3rem] underline" href="/video">
            過去開催講座アーカイブ
          </a>
          <div class="siteHeaderPanel flex items-center" v-if="user?.loginName">
            <img src="https://static-jp.theckb.com/static-asset/sellerstation/ava.png" alt=""
              class="w-[1.5rem] h-[1.5rem] mr-[0.5rem]" />

            <div class=" text-left">
              <div>Welcome</div>
              <div class=" flex items-center relative user-name">
                <span class="font-[800] mr-[0.16rem] cursor-pointer">
                  {{ user?.loginName }}
                </span>
                <DownOutlined class=" text-[#FFFFFFA6] text-[0.4375rem] ml-[0.1]" />
                <div class="absolute top-[20px] bg-[#fff] p-[1.25rem] w-[14.4rem] right-0 user-name-handle">
                  <div class="flex items-center pb-[1rem] border-b-[0.0625rem] border-[#F0F0F0]">
                    <img src="https://static-jp.theckb.com/static-asset/sellerstation/ava.png" alt="" />
                    <span class="text-[0.875rem] font-bold text-[#000] ml-[0.5rem] line-clamp-1">
                      {{ user?.loginName }}
                    </span>
                  </div>
                  <div>
                    <span class="text-[#00000073] leading-[2.28rem] mt-[0.25rem] cursor-pointer" @click="loginOut">
                      ログアウト
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class=" flex items-center text-left" v-else>
            <img src="https://static-jp.theckb.com/static-asset/sellerstation/avator.png" alt=""
              class=" w-[1.5rem] h-[1.5rem] mr-[0.5rem]" />
            <div class=" text-[0.75rem] leading-[1rem]">
              <div>Welcome</div>
              <a href="/account/signin" class=" font-[800]">
                ログイン
              </a>
              <span>/</span>
              <a href="/account/register" class=" font-[800]">
                新規登録
              </a>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div className="h-[3rem] bg-[#000] flex items-center justify-between px-[1rem]"
        v-if="[0, 2].includes(headerType)">
        <img src="https://static-jp.theckb.com/static-asset/sellerstation/just_logo.png" alt="" className="h-[1.75rem]"
          @click="jumpIndex" />
        <span className="flex-1" />
        <a className="text-[0.875rem] text-[#fff] mr-[1.5rem] underline" href="/video" v-if="[0].includes(headerType)">
          過去開催講座アーカイブ
        </a>
        <img src="https://static-jp.theckb.com/static-asset/sellerstation/user_icon.png" alt="" className="w-[2rem]"
          @click="jump" />
      </div>
      <div
        className="h-[3rem] bg-[#fff] shadow-[0_0.25rem_0.625rem_0_rgba(0,0,0,0.08)] flex items-center justify-center relative z-[100]"
        v-else>
        <img src="https://static-jp.theckb.com/static-asset/sellerstation/seller_logo.png" alt=""
          className="w-[8.62338rem]" />
      </div>
    </template>
  </div>
</template>
<script lang="ts" setup>
import { isH5 } from '@/const';
import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
const store = useStore()
const router = useRouter()
const route = useRoute()
const headerType = ref(0)
const user = computed(() => store.getters.userInfo)
const jumpIndex = () => {
  router.push('/')
}
const loginOut = () => {
  store.commit('user/SET_TOKEN', '')
  store.commit('user/SET_USER_INFO', {})
  window.location.href = '/'
}
watch(() => route.path, (newPath) => {
  console.log('newPath', newPath)
  headerType.value = 0
  if (newPath.includes('/account')) {
    headerType.value = 1;
  }
  if (newPath.includes('/video')) {
    headerType.value = 2
  }

}, {
  immediate: true
})

const jump = () => {
  if (!store.getters.token) {
    router.push('/account/signin')
  }
}
</script>
<style lang="scss" scoped>
.layoutHeader {
  padding: 0;
  height: 60px;
}

.siteHeader {
  /* position: fixed;
	top: 0; */
  box-sizing: border-box;
  max-width: 1440px;
  min-width: 1200px;
  width: 100%;
  height: 60px;
  padding: 14px 48px;
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  align-items: center;
  background: var(--Neutral-Absolute-13_black, #000);
  color: #fff;
  text-align: center;
}

.siteHeaderTabs {
  flex-grow: 1;
  box-sizing: border-box;
  padding: 0 100px;
  display: flex;
  color: #fff;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 900;
  line-height: 24px;
  /* 150% */
}

.siteHeaderTabs div {
  margin-right: 48px;
  cursor: pointer;
}

.siteHeaderPanel {
  flex-shrink: 0;
}

.siteHeaderExchange {
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 16px;
}

.siteHeaderLogin {
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 16px;
}

.siteHeaderCart {
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 16px;
}

.siteHeaderPopover .ant-popover-content .ant-popover-inner {
  padding: 0;
  border: 1px #fff solid;
  border-radius: 16px;
}

.user-name {
  .user-name-handle {
    display: none;
    border-radius: 1rem;
  }

  &:hover {
    .user-name-handle {
      display: block;

    }
  }
}
</style>
